import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ExistenciasApiService {
  apiURL: string = config.API_DATA_URL + '/Existencias';
  data: any[] = [];

  constructor(public http: HttpClient) { }

  public GetData(url: string): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + url, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public PostData(url: string, data: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(data);
    return this.http.post(this.apiURL + url, param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/existencias.service.ts